"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPurchase',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    purchase: function purchase(row) {
      return row && (row.purchaseOrder || row.order) || {};
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationPurchaseOrderListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    runAction: function runAction(row, action) {
      var _this2 = this;
      var order = this.purchase(row);
      this.$confirm("\u786E\u8BA4\u6267\u884C ".concat(action, "\uFF1F")).then(function () {
        (0, _decoration.decorationPurchaseOrderActionApi)(order.id, {
          action: action,
          version: order.version
        }).then(function () {
          _this2.$message.success('已更新');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};